export const BUSINESS = {
  name: "Studio Kosmetyki Nowoczesnej BEAUTIX",
  shortName: "BEAUTIX",
  tagline: "nails & beauty",
  address: {
    street: "ul. Ligocka 80",
    postalCode: "40-569",
    city: "Katowice",
    country: "Polska",
  },
  phones: [
    { label: "Telefon stacjonarny", number: "32 203 58 65", tel: "+48322035865" },
    { label: "Telefon komórkowy", number: "794 000 270", tel: "+48794000270" },
  ],
  email: "beautixpolska@gmail.com",
  social: {
    facebook: "https://www.facebook.com/najlepsze.paznokcie.w.miescie/",
    instagram: "https://www.instagram.com/beautix_skn/",
    googleMaps: "https://maps.app.goo.gl/BUQApDAZWBdsfYDF7",
  },
  hours: [
    { day: "Poniedziałek – Piątek", value: "08:00 – 18:00" },
    { day: "Sobota", value: "08:00 – 13:00" },
    { day: "Niedziela", value: "Nieczynne" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=Ligocka+80,+40-569+Katowice&output=embed",
  googleReviewUrl:
    "https://maps.app.goo.gl/BUQApDAZWBdsfYDF7",
};

export const IMAGES = {
  heroHome:
    "/assets/ig/nails-dots-rings.jpg",
  nails:
    "/assets/ig/nails-baby-boomer.jpg",
  nailsAlt:
    "/assets/ig/dots-french.jpg",
  podiatry:
    "/assets/ig/podolog-work.jpg",
  podiatryAlt:
    "/assets/ig/podolog-lampa.jpg",
  face:
    "/assets/ig/regeneracja.jpg",
  faceAlt:
    "/assets/ig/kosmetyka-twarzy.jpg",
  interior:
    "/assets/ig/wiosenne-przebudzenie.jpg",
  logo: "/assets/beautix-logo-transparent.png",
};

/**
 * Zdjęcia BEAUTIX z Instagrama @beautix_skn — najnowsze publikacje.
 * Zamawiane od najnowszych do starszych. Wszystkie zdjęcia pochodzą
 * z publicznych postów salonu (Instagram: @beautix_skn).
 */
export const BEAUTIX_IG = {
  pediluxFrench: {
    src: "/assets/ig/sakura-lace.jpg",
    alt: "Ślubny manicure — sakura na nude, ręcznie malowane kwiaty wiśni · BEAUTIX Katowice",
    date: "2025-11-11",
    tag: "Sakura",
    caption: "Ręcznie malowana sakura na welonie",
  },
  pediluxPink: {
    src: "/assets/ig/pedilux-cover.jpg",
    alt: "Manicure hybrydowy w głębokim czekoladowym brązie — krótkie migdałki · BEAUTIX Katowice",
    date: "2025-10-20",
    tag: "Chocolate",
    caption: "Głęboka czekoladowa hybryda na krótkich paznokciach",
  },
  dotsFrench: {
    src: "/assets/ig/dots-french.jpg",
    alt: "Pastelowe kwiaty 3D na krótkich paznokciach — ręcznie malowane · BEAUTIX Katowice",
    date: "2026-03-31",
    tag: "Flower nails",
    caption: "Pastelowe kwiaty na nude — ręcznie malowane",
  },
  wiosnaManicure: {
    src: "/assets/ig/wiosna-manicure.jpg",
    alt: "Delikatny róż z akwarelowymi kwiatami — manicure hybrydowy · BEAUTIX Katowice",
    date: "2026-04-01",
    tag: "Akwarela",
    caption: "Subtelny róż i akwarelowe kwiaty",
  },
  wiosennePaznokcie: {
    src: "/assets/ig/wiosenne-paznokcie.jpg",
    alt: "Wiosenne paznokcie — kropki na nude · BEAUTIX Katowice",
    date: "2026-04-01",
    tag: "Wiosenne",
    caption: "Wiosenne paznokcie 2026",
  },
  shortSweet: {
    src: "/assets/ig/dots-bw.jpg",
    alt: "Autorskie zdobienia paznokci — czarno-białe kropki na migdałkach · BEAUTIX Katowice",
    date: "2025-10-20",
    tag: "Black & White",
    caption: "Autorskie zdobienia — czarno-białe kropki",
  },
  sonoforeza: {
    src: "/assets/ig/nails-shimmer.jpg",
    alt: "Delikatny brokatowy manicure hybrydowy na białym papierze · BEAUTIX Katowice",
    date: "2026-05-26",
    tag: "Shimmer",
    caption: "Delikatny brokatowy manicure hybrydowy",
  },
  peelingProduct: {
    src: "/assets/ig/dots-pastel-french.jpg",
    alt: "Nude z pastelowym frenchem i drobnymi kropkami · BEAUTIX Katowice",
    date: "2026-03-25",
    tag: "Pastel french",
    caption: "Nude z pastelowym frenchem i kropkami",
  },
  wiosennePrzebudzenie: {
    src: "/assets/ig/wiosenne-przebudzenie.jpg",
    alt: "Wiosenne przebudzenie skóry — mezoterapia i egzosomy · BEAUTIX Katowice",
    date: "2026-03-01",
    tag: "Mezoterapia",
    caption: "Wiosenne przebudzenie skóry",
  },
  grzybicaTherapy: {
    src: "/assets/ig/white-bridal.jpg",
    alt: "Ślubny manicure — mleczna biel na kwadratowych migdałkach z biżuterią · BEAUTIX Katowice",
    date: "2026-01-30",
    tag: "Ślubny",
    caption: "Ślubny manicure — mleczna biel",
  },
  helloManicure: {
    src: "/assets/ig/hello-manicure.jpg",
    alt: "Elegancki french manicure hybrydowy z biżuterią · BEAUTIX Katowice",
    date: "2026-04-22",
    tag: "French",
    caption: "Klasyczny french na krótkich paznokciach",
    objectFit: "contain",
  },
};

/**
 * Galeria: wyłącznie zdjęcia z Instagrama @beautix_skn, uporządkowane
 * od najnowszych do starszych.
 */
export const BEAUTIX_GALLERY = [
  BEAUTIX_IG.pediluxFrench,
  BEAUTIX_IG.pediluxPink,
  BEAUTIX_IG.dotsFrench,
  BEAUTIX_IG.wiosnaManicure,
  BEAUTIX_IG.wiosennePaznokcie,
  BEAUTIX_IG.sonoforeza,
  BEAUTIX_IG.shortSweet,
  BEAUTIX_IG.peelingProduct,
  BEAUTIX_IG.grzybicaTherapy,
  BEAUTIX_IG.helloManicure,
];

export const SEO_KEYWORDS = {
  nails: [
    "stylizacja paznokci Katowice",
    "manicure hybrydowy Katowice",
    "paznokcie żelowe Katowice",
    "manicure tytanowy Katowice",
    "dobry salon manicure Katowice",
  ],
  podology: [
    "podolog Katowice",
    "gabinet podologiczny Katowice",
    "wrastający paznokieć Katowice",
    "pedicure leczniczy Katowice",
    "usuwanie odcisków Katowice",
  ],
  face: [
    "kosmetyka twarzy Katowice",
    "masaż Kobido Katowice",
    "oczyszczanie twarzy Katowice",
    "mezoterapia twarzy Katowice",
    "stymulatory tkankowe Katowice",
  ],
};
